import "./UserMenuAccessModal.css";
import Switch from "./Switch";

export default function UserMenuAccessModal({
  open,
  onClose,
  loadingAccess,
  accessData,
  toggleAccess,
  disabled,
  saveAccessChanges,
}) {

  if (!open) return null;

  return (
    <div className="overlay">
      <div className="modal">
        {/* <h2>Company Access</h2> */}

        <div className="modal-header">
          <h2 className="modal-title">Company Access</h2>
          <button
            type="button"
            className="close-top-btn"
            aria-label="Close"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        {loadingAccess ? (
          <p className="loading">Loading...</p>
        ) : (
          <div className="content">
            {accessData.map((menu) => (
              <div key={menu.id} className="card">
                {/* Menu Header */}
                <div className="row">
                  <strong>{menu.name}</strong>
                  <Switch
                    checked={Boolean(menu.is_active)}
                    onChange={() => toggleAccess(menu.id)}
                  />
                </div>

                {/* Subpanels */}
                {menu.subpanels.map((sub) => (
                  <div
                    key={sub.id}
                    className={`subcard ${sub.is_active ? "active" : ""}`}
                  >
                    <div className="row">
                      <span>{sub.name}</span>
                      <Switch
                        checked={Boolean(sub.is_active)}
                        onChange={() => toggleAccess(menu.id, sub.id)}
                      />
                    </div>

                    {sub.subtitles?.length > 0 && (
                      <div className="subtitles">
                        {sub.subtitles.map((st) => (
                          <div
                            key={st.id}
                            className={`subtitle ${st.is_active ? "active" : ""
                              }`}
                          >
                            <span>{st.name}</span>
                            <Switch
                              checked={Boolean(st.is_active)}
                              onChange={() =>
                                toggleAccess(menu.id, sub.id, st.id)
                              }
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}

            <button
              disabled={disabled}
              className="btn primary"
              onClick={saveAccessChanges}
            >
              {disabled ? "Saving...." : "Save Changes"}
            </button>
            {/* <button className="btn outline" onClick={onClose}>
              Close
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
}
